export default function Star2({
  fill = '#fff',
  width = '5',
  height = '7',
  className,
}: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      width={width}
      height={height}
      viewBox='0 0 5 7'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      className={className}
    >
      <path
        d='M2.5 1.59766C2.8588 2.3482 3.39376 3.00186 4.06152 3.5C3.39399 3.99797 2.85879 4.65116 2.5 5.40137C2.14109 4.65092 1.60532 3.99803 0.9375 3.5C1.60556 3.0018 2.14109 2.34843 2.5 1.59766Z'
        fill={fill}
        stroke='white'
      />
    </svg>
  );
}
